// import html2canvas from "html2canvas";

// export const handleDownloadChart = (id) => {
//   const chartElement = document.getElementById(id);

//   if (!chartElement) return;

//   html2canvas(chartElement).then((canvas) => {
//     const link = document.createElement("a");
//     link.download = "TopClientsChart.png";
//     link.href = canvas.toDataURL("image/png");
//     link.click();
//   });
// };
import html2canvas from "html2canvas";

export const handleDownloadChart = (id, title) => {
  const chartElement = document.getElementById(id);

  if (!chartElement) return;

  html2canvas(chartElement).then((canvas) => {
    const context = canvas.getContext("2d");

    // Add the title dynamically to the canvas
    context.font = "bold 20px Arial"; // Set font style
    context.fillStyle = "#000"; // Set text color
    context.textAlign = "center"; // Center the text
    context.fillText(title, canvas.width / 2, 30); // Position the title at the top center

    // Create a download link
    const link = document.createElement("a");
    link.download = `${title.replace(/\s+/g, "_")}.png`; // Use the title as the filename
    link.href = canvas.toDataURL("image/png");
    link.click();
  });
};